import { render } from "./registrarGarantia.vue?vue&type=template&id=32f67056&scoped=true"
import script from "./registrarGarantia.vue?vue&type=script&lang=js"
export * from "./registrarGarantia.vue?vue&type=script&lang=js"

import "./registrarGarantia.vue?vue&type=style&index=0&id=32f67056&scoped=true&lang=css"
import "./registrarGarantia.vue?vue&type=style&index=1&id=32f67056&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f67056"]])

export default __exports__